import { carouselItems } from '@/mocks/homeData';

const tagColorMap: Record<string, string> = {
  HOT: 'bg-primary-500 text-background-50',
  NEW: 'bg-accent-500 text-background-50',
  TRENDING: 'bg-secondary-600 text-background-50',
  EXCLUSIVE: 'bg-primary-600 text-background-50',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            深度挖掘娱乐圈最受关注的五大热点事件
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.slice(0, 3).map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className={`absolute top-3 left-3 text-[10px] px-2 py-0.5 rounded-full font-semibold whitespace-nowrap ${tagColorMap[item.tag] || 'bg-secondary-500 text-background-50'}`}>
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 text-[10px] px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-700 font-medium whitespace-nowrap">
                  {item.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.excerpt}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {carouselItems.slice(3, 5).map((item, i) => (
            <div key={i + 3} className="group flex flex-col sm:flex-row bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative w-full sm:w-[200px] h-[160px] sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className={`absolute top-3 left-3 text-[10px] px-2 py-0.5 rounded-full font-semibold whitespace-nowrap ${tagColorMap[item.tag] || 'bg-secondary-500 text-background-50'}`}>
                  {item.tag}
                </span>
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center">
                <span className="text-[10px] text-accent-600 font-medium mb-1">{item.category}</span>
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.excerpt}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}